export default {
      id: "sensors__illumination-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__illumination",
      toString: function () {
        return this.url;
      }
    }